export class OOOrderTypeThrottle {
	guid: string;
	orderTypeKey: number;
	throttleOrderMinutes: number;
	throttleOrderCount: number;
	throttleOrderRevenue: number;
	active: boolean;
	startTime: string;
	endTime: string;
	timeBased: boolean;

	public constructor(init?: Partial<OOOrderTypeThrottle>) {
		Object.assign(this, init);
	}
}
